module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Menu-icon_black-66fa146b040fa85673194ca8161ece2e.svg";